// 질문 한페이지에 2개
// 오늘날짜로 신청, 애니메이션 슬라이드

import React, { useEffect, useRef, useState } from "react";
// import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { validateName, validatePhoneNumber } from "../utils/validation";
import { handleFormSubmit } from "../handlers/formHandlers";
import PhoneNumberInput from "../components/PhoneNumberInput";
import BenefitPeriod from "../components/BenefitPeriod";
import PrivacyPolicyAgree from "../components/PrivacyPolicyAgree";
import {
  options,
  phoneFirstOptions,
  prohibitedWords,
} from "../utils/dummyData";

import "./randingStyle1.scss";
import CuteLoader from "../components/CuteLoader";
import PrivacyContent from "./PrivacyContent";

function RandingStyle21({
  urlCode,
  urlCodeSettingId,
  img1Path,
  img2Path,
  img3Path,
  img4Path,
  img5Path,
  img6Path,
  img20Path,
  videoPath,
  video2Path,
  videoBottmIMG,
  formFieldColor,
  qTitleImg1Path,
  qTitleImg2Path,
  keepBTN,
  qOptionImgPath,
  qOptions,
  qTitleColor,
  qOptionColor,
  postBTN,
  companyName,
  privacyCompanyName,
  footerPath,
  // 랜딩 별로 태그 설정인 경우

  apiUrl,
  eventDates,
  privacyMessage,
  kakaotalk,
  carrotTag,
}) {
  const navigate = useNavigate();
  const privacyName = privacyCompanyName || companyName || "수집주체명";

  // 상태 관리
  const [name, setName] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false); // 버튼 상태 관리
  const [phoneNumber, setPhoneNumber] = useState({
    first: "",
    second: "",
    third: "",
  });
  const [selectedOption, setSelectedOption] = useState("");
  const [isAgreed, setIsAgreed] = useState(false);
  const [isPrivacyPolicyModal, setIsPrivacyPolicyModal] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);

  // 유효성 검사
  const validateInput = () => {
    return (
      validateName(name, prohibitedWords) && validatePhoneNumber(phoneNumber)
    );
  };

  // 이벤트 핸들러
  const handlePhoneNumberChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/[^0-9]/g, "");

    setPhoneNumber((prev) => ({
      ...prev,
      [name]: numericValue,
    }));
  };

  const handleSelectImplant = (option) => {
    setSelectedOption(option);
  };

  const togglePrivacyPolicyModal = () => {
    setIsPrivacyPolicyModal(!isPrivacyPolicyModal);
  };

  const handleSubmit = () => {
    handleFormSubmit({
      name,
      phoneNumber,
      selectedOption,
      isAgreed,
      submitCount,
      setSubmitCount,
      validateInput,
      urlCode,
      urlCodeSettingId,
      navigate,
      setIsSubmitting,

      apiUrl,
      kakaotalk,
      carrotTag,
    });
  };

  const [loading, setLoading] = useState(true); // 초기 로딩 상태

  useEffect(() => {
    if (videoPath) {
      const timer = setTimeout(() => setLoading(false), 600); // 1초 후 로딩 해제
      return () => clearTimeout(timer); // 컴포넌트 언마운트 시 타이머 정리
    }
    setLoading(false); // videoPath가 없으면 로딩 없음
  }, [videoPath]);

  //실시간 신청 현황 아이템
  // 날짜 + 랜덤 시간 생성 함수
  const formatDate = (date) => {
    const hours = String(Math.floor(Math.random() * 24)).padStart(2, "0");
    const minutes = String(Math.floor(Math.random() * 60)).padStart(2, "0");
    return `${date.getFullYear()}.${
      date.getMonth() + 1
    }.${date.getDate()} ${hours}:${minutes}`;
  };

  const today = new Date();

  const slideItems = [
    {
      title: "신청했습니다~!",
      name: "김**",
      phone: "010-****-**78",
      date: formatDate(today),
    },
    {
      title: "신청했습니다~!",
      name: "박**",
      phone: "010-****-**65",
      date: formatDate(today),
    },
    {
      title: "신청했습니다~!",
      name: "이**",
      phone: "010-****-**11",
      date: formatDate(today),
    },
    {
      title: "신청했습니다~!",
      name: "조**",
      phone: "010-****-**00",
      date: formatDate(today),
    },
    {
      title: "신청했습니다~!",
      name: "최**",
      phone: "010-****-**22",
      date: formatDate(today),
    },
  ];
  const settings = {
    infinite: true,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  return (
    <div className="form-container">
      {loading && <CuteLoader />} {/* 로딩 상태일 때 스피너 렌더링 */}
      <div className="step2">
        {img1Path && <img src={img1Path} alt="임플란트 고민중이세요?" />}
        {img2Path && <img src={img2Path} alt="임플란트 고민중이세요?" />}
        {img3Path && <img src={img3Path} alt="임플란트 고민중이세요?" />}
        {img4Path && <img src={img4Path} alt="임플란트 고민중이세요?" />}
        {img5Path && <img src={img5Path} alt="임플란트 고민중이세요?" />}
        {img6Path && <img src={img6Path} alt="임플란트 고민중이세요?" />}

        {videoPath && (
          <video
            autoPlay
            playsInline
            onClick={(e) => e.preventDefault()} // 클릭 이벤트 제거
            loop={false}
            muted
            style={{ width: "100%" }}
          >
            <source src={videoPath} type="video/mp4" />
            {/* 브라우저가 비디오를 지원하지 않을 경우 */}
            Your browser does not support the video tag.
          </video>
        )}

        {videoBottmIMG && (
          <img src={videoBottmIMG} alt="임플란트 고민중이세요?" />
        )}

        <div className="realtime-status-slider">
          <div className="slider-track">
            {[...slideItems, ...slideItems].map((item, idx) => (
              <div className="slide-item" key={idx}>
                <p className="title">{item.title}</p>
                <p>
                  {item.name} | {item.phone}
                </p>
                <p>{item.date}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="qBox">
          {qTitleImg1Path ? (
            <img src={qTitleImg1Path} />
          ) : (
            <div className="qTitleSmall">
              <span style={{ color: qTitleColor }}>Q1.</span>
              <p>임플란트 필요한 개수는?</p>
            </div>
          )}
          <div
            className="qOptions row"
            style={{
              transform: " translateX(0%)",
              ...(qOptions && { width: "100%" }),
            }}
          >
            {(qOptions || options)
              .filter((option) => option !== "상담필요")
              .map((option, index) => (
                <img
                  style={{
                    width:
                      qOptions && qOptions.length > 3
                        ? `calc(100% / ${qOptions.length})`
                        : "32%",
                  }}
                  key={index}
                  src={`${
                    qOptionImgPath ||
                    `${process.env.REACT_APP_CDN_BASE}/images/qOptions/radio`
                  }/${
                    selectedOption === option
                      ? `${qOptionColor || "blue"}/qoption${index + 1}(1)`
                      : `qoption${index + 1}`
                  }.png`}
                  alt={option}
                  onClick={() => handleSelectImplant(option)}
                />
              ))}
          </div>
          {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
          {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
          {qTitleImg1Path ? (
            <img src={qTitleImg2Path} />
          ) : (
            <div className="qTitleSmall">
              <span style={{ color: qTitleColor }}>Q2.</span>
              <p>귀하의 성함과 연락처를 입력해주세요</p>
            </div>
          )}
          <form
            className="formBox"
            onSubmit={(e) => {
              e.preventDefault(); // 기본 제출 동작 방지
              handleSubmit(); // 기존 handleSubmit 호출
            }}
          >
            <div
              className={`formField ${
                formFieldColor === "white" ? "white" : ""
              }`}
            >
              <label htmlFor="name">이름</label>
              <input
                type="text"
                id="name"
                maxLength="10"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <PhoneNumberInput
              phoneNumber={phoneNumber}
              phoneFirstOptions={phoneFirstOptions}
              handlePhoneNumberChange={handlePhoneNumberChange}
              formFieldColor={formFieldColor}
            />
            <PrivacyPolicyAgree
              isAgreed={isAgreed}
              setIsAgreed={setIsAgreed}
              togglePrivacyPolicyModal={togglePrivacyPolicyModal}
              privacyMessage={privacyMessage}
            />
            <p className="benefitInfo">
              {eventDates && (
                <>
                  <BenefitPeriod /> <br />
                </>
              )}
              이벤트 대상자 : 해당 매체 이용자
            </p>
            {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
            {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
            {isPrivacyPolicyModal && (
              <div className="modalOverlay" onClick={togglePrivacyPolicyModal}>
                <div
                  className="privacyPolicyContent"
                  onClick={(e) => e.stopPropagation()}
                >
                  <PrivacyContent companyName={privacyName} />
                </div>
              </div>
            )}
            <button
              type="submit"
              className="sendBtnBox"
              style={{ margin: "25px 0 30px 0" }}
              disabled={isSubmitting}
            >
              <img src={postBTN} alt="신청하기" />
            </button>
          </form>
        </div>
        {img20Path && <img src={img20Path} alt="임플란트 고민중이세요?" />}
      </div>
      <div className="footer">
        {footerPath && <img src={footerPath} alt="푸터" />}{" "}
      </div>
    </div>
  );
}

export default RandingStyle21;
